import type from "./types";

const initialState = {
  selectedTemplate : null,
  condition_background: "#70AD47",
  condition_color: "#EAFFDC",
  titleFontColor: "",
  subTitleFontColor: "",
  selectedTimelineTemplate: null
}


export function saveTem(state = initialState, action = {} ) {
  switch(action.type) {
    case type.SELECTED_TEMPLATE:
    return {
      ...state,
      selectedTemplate: action.data
    }
    case type.SELECTED_TIMELINE_TEMPLATE: 
    return {
      ...state,
      selectedTimelineTemplate: action.data
    }
    case type.CONDITION_COLORS_BACKGROUND:
      return {
        ...state,
        condition_background : action.data
        
      }
      case type.CONDITION_COLORS_FONTCOLOR:
      return {
        ...state,
        condition_color : action.data
      }  
      case type.TITLE_FONT_COLOR:
      return {
        ...state,
        titleFontColor: action.data
      }
    case type.SUBTITLE_FONT_COLOR:
      return {
        ...state,
        subTitleFontColor: action.data
      }
     case type.BATCH_FONT_COLOR:
      return {
        ...state,
        batchFontColor: action.data
      }
    default:
      return state;
  }
}

